import React from 'react';

import './AboutChatbot.css'

const AboutChatbot = () => {
  return (
    <div className='content-wrapper'>
      <h1>About Chatbot</h1>
      <p>This section gives information about the chatbot.</p>
    </div>
  );
};

export default AboutChatbot;
